import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const ReadConsentIndex = () => {
    const navigate = useNavigate();

    const filterConfig = useMemo(() => [
        {
            type: "text",
            name: "userName",
            label: "User",
            placeholder: "Search by user..."
        }
    ], []);

    const columns = useMemo(() => [
        { 
            title: 'User', 
            dataIndex: 'userName', 
            key: 'userName', 
            sortable: true 
        }
    ], []);

    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/readConsent/edit/${record.readConsentID}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="Read Consent"
            apiEndpoint="/ReadConsent/getAllPaginated"
            toggleActiveEndpoint="/ReadConsent/toggleActive"
            toggleDeletedEndpoint="/ReadConsent/toggleDeleted"
            newRoute="/readConsent/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="readConsentID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default ReadConsentIndex;
